
import { TReplyValuesDataTableData } from "./ReplyValuesDataTableMeta";

const ReplyValuesTableFakeData: TReplyValuesDataTableData[] = [
    {
        condition: {
            resp: "000",
            tick: "*",
            diary: "*",
            cash: "*",
            seq: "1",
        },
        result: {
            type: true,
            stateNum: "162",
            screenNum: "014",
            func: "5",
            receipt: "",
            diary2: "",
        },
    },
    {
        condition: {
            resp: "155",
            tick: "*",
            diary: "*",
            cash: "*",
            seq: "1",
        },
        result: {
            type: false,
            stateNum: "165",
            screenNum: "085",
            func: "5",
            receipt: "",
            diary2: "",
        },
    },
    {
        condition: {
            resp: "000",
            tick: "*",
            diary: "*",
            cash: "*",
            seq: "3",
        },
        result: {
            type: false,
            stateNum: "160",
            screenNum: "041",
            func: "3",
            receipt: "",
            diary2: "6",
        },
    },
    {
        condition: {
            resp: "000",
            tick: "2",
            diary: "1",
            cash: "*",
            seq: "2",
        },
        result: {
            type: false,
            stateNum: "161",
            screenNum: "039",
            func: "3",
            receipt: "",
            diary2: "6",
        },
    },
    {
        condition: {
            resp: "000",
            tick: "1",
            diary: "*",
            cash: "**",
            seq: "2",
        },
        result: {
            type: false,
            stateNum: "161",
            screenNum: "039",
            func: "3",
            receipt: "",
            diary2: "6",
        },
    },
]

export default ReplyValuesTableFakeData;